import React from "react";
import { useTranslation } from "react-i18next";
import Button from "src/components/Button";
import Header from "src/components/Header";
import SEO from "src/components/layout/SEO";
import useTenant from "src/hooks/api/services/tenants/useTenant";
import useAuth from "src/hooks/selectors/useAuth";

const NotFoundView = () => {
	const auth = useAuth();
	const { tenant } = useTenant();
	const { t } = useTranslation("auth-view", {
		keyPrefix: "not-found",
	});
	return (
		<>
			<SEO title={"Pagina niet gevonden"} />
			<Header type="student" hideLogo full>
				<div className="flex flex-1 flex-col justify-center">
					<div className="flex flex-col gap-4 mb-8">
						<h1>{t("title")}</h1>
						<p>{t("description")}</p>
					</div>
					<div className="flex items-center gap-4">
						{auth.id ? (
							<Button noBlank to="/dashboard">
								{t("buttons.dashboard")}
							</Button>
						) : (
							<>
								<Button noBlank to="/login">
									{t("buttons.login")}
								</Button>
								<Button
									noBlank
									type="outlined"
									href={tenant?.urls?.public}
								>
									{t("buttons.home")}
								</Button>
							</>
						)}
					</div>
				</div>
			</Header>
		</>
	);
};

export default NotFoundView;
